import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Router from './route/Index';
import { AuthProvider } from './context/auth.context';

import ThemeProvider from './layout/provider/Theme';
const queryClient = new QueryClient();
const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ThemeProvider>
          <Router />
        </ThemeProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
};
export default App;
